import {
  RECEIVABLE_PREVIEW,
  RECEIVABLE_GROUP_REPORT,
  RECEIVABLE_REPORT,
  MANUAL_RECEIVABLE_ADDRESS,
  RECEIVABLE_LINK,
  MANUAL_RECEIVABLE_RESULT,
  NEW_RECEIVABLE_REPORT,
} from '@portal/actions/actionTypes';
import {
  GetReceivableAction,
  GetReceivableGroupAction,
  GetReceivablePreviewAction,
  GetAddressAction,
  GetReceivableLink,
  GetManualReceivableResult,
} from '@portal/actions/receivable';

const initialState: reducers.ReceivableReducer = {
  receivableGroupsReport: [],
  receivableReport: [],
  countReceivableGroup: 0,
  countReceivable: 0,
  receivablePreview: null,
  manualAddress: null,
  receivableLink: null,
  manualReceivableResult: null,
  newReceivableReport: [],
};

const receivableReducer = (
  state = initialState,
  action:
    | GetReceivableAction
    | GetReceivableGroupAction
    | GetReceivablePreviewAction
    | GetAddressAction
    | GetReceivableLink
    | GetManualReceivableResult
) => {
  const { type, payload } = action;
  switch (type) {
    case RECEIVABLE_REPORT:
      if (
        typeof payload === 'string' ||
        !payload ||
        'total' in payload ||
        'type' in payload ||
        !('rows' in payload)
      ) {
        return state;
      }
      state = {
        ...state,
        receivableReport: payload.rows as models.Receivable[],
        countReceivable: payload.count,
      };

      break;

    case RECEIVABLE_GROUP_REPORT:
      if (
        typeof payload === 'string' ||
        !payload ||
        'total' in payload ||
        'type' in payload ||
        !('rows' in payload)
      ) {
        return state;
      }
      state = {
        ...state,
        receivableGroupsReport: payload.rows as models.ReceivableGroup[],
        countReceivableGroup: payload.count,
      };
      break;

    default:
      return state;

    case RECEIVABLE_PREVIEW:
      if (
        typeof payload === 'string' ||
        Array.isArray(payload) ||
        (payload && !('total' in payload))
      ) {
        return state;
      }
      state = {
        ...state,
        receivablePreview: payload,
      };
      break;

    case MANUAL_RECEIVABLE_ADDRESS:
      if (
        typeof payload === 'string' ||
        Array.isArray(payload) ||
        (payload && !('zipCode' in payload))
      ) {
        return state;
      }
      state = {
        ...state,
        manualAddress: payload,
      };
      break;

    case RECEIVABLE_LINK:
      if (payload && typeof payload !== 'string') {
        return state;
      }
      state = {
        ...state,
        receivableLink: payload,
      };
      break;

    case MANUAL_RECEIVABLE_RESULT:
      if (
        typeof payload === 'string' ||
        (payload && (!('amount' in payload) || !('type' in payload)))
      ) {
        return state;
      }
      state = {
        ...state,
        manualReceivableResult: payload,
      };
      break;

    case NEW_RECEIVABLE_REPORT:
      state = {
        ...state,
        newReceivableReport: payload as models.NewReceivableList[],
      };
      break;
  }

  return state;
};

export default receivableReducer;
